// removed by extract-text-webpack-plugin
module.exports = {"picker":"_2_EGRrtxe4WBtAv6pR5Dp6","pick":"_1jXk9eH4VMBb1mXLjxzMaM"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ContainerPicker/style.scss
// module id = 957
// module chunks = 0